/**
 * Blockiert Worker-Aktionen (Logout), solange offene POS-Entwürfe existieren.
 */

import { getDraftData, isReadModelReady } from '../services/cacheReadModel';
import { getCurrentBusinessId } from './sharedCore';

export function countWorkerDrafts(businessId = getCurrentBusinessId()) {
  if (!businessId) return 0;
  if (!isReadModelReady()) return 0;
  const drafts = getDraftData(businessId);
  return Array.isArray(drafts) ? drafts.length : 0;
}

export function getWorkerDraftBlockMessage(count, language = 'fr') {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  const isArabic = language === 'ar';
  return isArabic
    ? `لا يمكن تسجيل الخروج. يوجد ${n} مسودة/مسودات غير محفوظة. يرجى حذفها أو حفظها أولاً.`
    : `Impossible de se déconnecter. Il y a ${n} brouillon(s) non sauvegardé(s). Veuillez les supprimer ou les sauvegarder d'abord.`;
}

export function getWorkerDraftBlock(businessId, language = 'fr') {
  const count = countWorkerDrafts(businessId);
  if (count <= 0) return { blocked: false, count: 0, message: null };
  return {
    blocked: true,
    count,
    message: getWorkerDraftBlockMessage(count, language)
  };
}
